import * as actions from '../actions/FinalScan'

const initialState = {
  error: '',
  warning: false,
  internationalAddressWarning: '',
  pendingTestPackageWarning: false,
  loading: false,
  scanSuccess: false,
  unscanSuccess: false,
  scanHistory: [],
  scannedPackage: null,
  unscanMode: false,
  updatePostageSuccess: false,
  packageCounts: {}
}

const FinalScanReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_SCANNED_PACKAGE_LOADER:
      return {
        ...state,
        loading: action.loading
      }
    case actions.POST_SCANNED_PACKAGE_SUCCESS:
      return {
        ...state,
        scanSuccess: action.scanSuccess
      }
    case actions.POST_SCANNED_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.FC_SCAN_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.POST_SCANNED_PACKAGE_WARNING:
      return {
        ...state,
        warning: action.isTest
      }
    case actions.POST_INTERNATIONAL_ADDRESS_WARNING:
      return {
        ...state,
        internationalAddressWarning: action.message
      }
    case actions.SET_PENDING_TEST_PACKAGE_WARNING:
      return {
        ...state,
        pendingTestPackageWarning: action.isPending
      }
    case actions.SET_SCANNED_PACKAGE:
      return {
        ...state,
        scannedPackage: action.scannedPackage
      }
    case actions.GET_SCANNED_PACKAGE_HISTORY:
      return {
        ...state,
        scanHistory: action.scanHistory
      }
    case actions.GET_SCANNED_PACKAGE_HISTORY_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.SET_UNSCAN_MODE:
      return {
        ...state,
        unscanMode: action.unscanMode
      }
    case actions.POST_UNSCAN_PACKAGE_SUCCESS:
      return {
        ...state,
        unscanSuccess: action.unscanSuccess
      }
    case actions.POST_UNSCAN_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.UPDATE_POSTAGE_SUCCESS:
      return {
        ...state,
        updatePostageSuccess: action.updatePostageSuccess
      }
    case actions.UPDATE_POSTAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.VALIDATE_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.GET_USER_DAILY_SCAN_COUNT:
      return {
        ...state,
        packageCounts: action.count
      }
    case actions.GET_USER_DAILY_SCAN_COUNT_ERROR:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default FinalScanReducer
